module.exports = __webpack_public_path__ + "static/media/1845_GardenDesign.346ec2a7.JPG";